import React, { useState } from "react";

const ContactInfo = () => {
  const [activeLocation, setActiveLocation] = useState("jaipur");

  // Location data
  const locations = {
    jaipur: {
      title: "Jaipur Office",
      address:
        "342, Vardhman Nagar, Badarwas, Ajmer Road, Jaipur- 302019",
      phone: "+91 9887-772727",
      email: "info@deeceeelevators.com",
      hours: "Monday - Friday: 9:00 AM - 6:00 PM, Saturday: 10:00 AM - 2:00 PM",
      mapUrl:
        "https://maps.app.goo.gl/EMSY5NK9g11TwgCT9",
    },
  };

  // Helper to copy text to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard!");
  };

  const location = locations[activeLocation];

  return (
    <div style={styles.container}>
      <h2 style={styles.mainTitle}>Contact Information</h2>

      {/* Location tabs */}
      <div style={styles.tabs}>
        <button
          style={{
            ...styles.tabButton,
            ...(activeLocation === "jaipur" ? styles.activeTab : {}),
          }}
          onClick={() => setActiveLocation("jaipur")}
        >
          <i className="fas fa-building" style={styles.tabIcon}></i>
          Jaipur Office
        </button>
      </div>

      {/* Location info card */}
      <div style={styles.infoCard}>
        <div style={styles.cardHeader}>
          <h3 style={styles.locationTitle}>{location.title}</h3>
          <a
            href={location.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.mapLink}
          >
            <i className="fas fa-map-marker-alt" style={styles.mapIcon}></i>
            View on Map
          </a>
        </div>

        <div style={styles.infoSection}>
          <div style={styles.infoIcon}>
            <i className="fas fa-map-marked-alt"></i>
          </div>
          <div style={styles.infoContent}>
            <h4 style={styles.infoLabel}>Address</h4>
            <p style={styles.infoText}>{location.address}</p>
            <button
              onClick={() => copyToClipboard(location.address)}
              style={styles.copyButton}
              aria-label="Copy address to clipboard"
            >
              <i className="far fa-copy"></i>
            </button>
          </div>
        </div>

        <div style={styles.infoSection}>
          <div style={styles.infoIcon}>
            <i className="fas fa-phone-alt"></i>
          </div>
          <div style={styles.infoContent}>
            <h4 style={styles.infoLabel}>Phone</h4>
            <p style={styles.infoText}>
              <a href={`tel:${location.phone}`} style={styles.contactLink}>
                {location.phone}
              </a>
            </p>
          </div>
        </div>

        <div style={styles.infoSection}>
          <div style={styles.infoIcon}>
            <i className="fas fa-envelope"></i>
          </div>
          <div style={styles.infoContent}>
            <h4 style={styles.infoLabel}>Email</h4>
            <p style={styles.infoText}>
              <a href={`mailto:${location.email}`} style={styles.contactLink}>
                {location.email}
              </a>
            </p>
          </div>
        </div>

        <div style={styles.infoSection}>
          <div style={styles.infoIcon}>
            <i className="fas fa-clock"></i>
          </div>
          <div style={styles.infoContent}>
            <h4 style={styles.infoLabel}>Working Hours</h4>
            <p style={styles.infoText}>{location.hours}</p>
          </div>
        </div>

        <div style={styles.callToAction}>
          <a href={`tel:${location.phone}`} style={styles.callButton}>
            <i className="fas fa-phone-alt" style={styles.callButtonIcon}></i>
            Call Now
          </a>
          <a href={`mailto:${location.email}`} style={styles.emailButton}>
            <i className="fas fa-envelope" style={styles.emailButtonIcon}></i>
            Send Email
          </a>
        </div>
      </div>

      {/* Emergency support banner */}
      <div style={styles.emergencyBanner}>
        <div style={styles.emergencyIcon}>
          <i className="fas fa-exclamation-circle"></i>
        </div>
        <div style={styles.emergencyContent}>
          <strong>24/7 Emergency Support:</strong> +91 98290 35345
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "10px",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    border: "1px solid rgba(0,0,0,0.04)",
  },
  mainTitle: {
    color: "#0A3A70",
    fontSize: "1.8rem",
    marginBottom: "20px",
    fontWeight: "600",
    fontFamily: "'Inter', sans-serif",
  },
  tabs: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
  },
  tabButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    backgroundColor: "#f0f7ff",
    border: "1px solid #e0eeff",
    borderRadius: "8px",
    color: "#1976D2",
    fontWeight: "500",
    fontSize: "0.95rem",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  tabIcon: {
    fontSize: "0.9rem",
  },
  activeTab: {
    backgroundColor: "#e0eeff",
    borderColor: "#1976D2",
    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.15)",
  },
  infoCard: {
    backgroundColor: "#f8faff",
    padding: "25px",
    borderRadius: "10px",
    marginBottom: "20px",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    borderBottom: "1px solid rgba(0,0,0,0.05)",
    paddingBottom: "15px",
  },
  locationTitle: {
    color: "#041E42",
    fontSize: "1.5rem",
    margin: 0,
    fontWeight: "600",
    fontFamily: "'Inter', sans-serif",
  },
  mapLink: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#1976D2",
    textDecoration: "none",
    fontSize: "0.9rem",
    fontWeight: "500",
    padding: "8px 12px",
    borderRadius: "6px",
    backgroundColor: "rgba(25, 118, 210, 0.08)",
    transition: "all 0.2s ease",
  },
  mapIcon: {
    fontSize: "0.9rem",
  },
  infoSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: "15px",
    marginBottom: "20px",
    position: "relative",
  },
  infoIcon: {
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(25, 118, 210, 0.1)",
    color: "#1976D2",
    borderRadius: "50%",
    fontSize: "1rem",
    flexShrink: 0,
  },
  infoContent: {
    flex: "1",
  },
  infoLabel: {
    margin: "0 0 5px 0",
    fontSize: "1rem",
    fontWeight: "600",
    color: "#333",
  },
  infoText: {
    margin: "0",
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.5",
  },
  contactLink: {
    color: "#1976D2",
    textDecoration: "none",
    fontWeight: "500",
  },
  copyButton: {
    position: "absolute",
    right: "0",
    top: "0",
    background: "transparent",
    border: "none",
    color: "#777",
    cursor: "pointer",
    padding: "5px",
    fontSize: "0.9rem",
  },
  callToAction: {
    display: "flex",
    gap: "15px",
    marginTop: "30px",
    flexWrap: "wrap",
  },
  callButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#1976D2",
    color: "white",
    border: "none",
    padding: "0 20px",
    height: "45px",
    borderRadius: "8px",
    fontSize: "0.95rem",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "none",
    boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
    transition: "all 0.3s ease",
    flexGrow: "1",
    textAlign: "center",
  },
  callButtonIcon: {
    fontSize: "0.9rem",
  },
  emailButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "white",
    color: "#1976D2",
    border: "1px solid #1976D2",
    padding: "0 20px",
    height: "45px",
    borderRadius: "8px",
    fontSize: "0.95rem",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "none",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    flexGrow: "1",
    textAlign: "center",
  },
  emailButtonIcon: {
    fontSize: "0.9rem",
  },
  emergencyBanner: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    backgroundColor: "#ffecb3",
    borderLeft: "4px solid #ffa000",
    padding: "12px 20px",
    borderRadius: "6px",
    color: "#7d5700",
  },
  emergencyIcon: {
    fontSize: "1.5rem",
    color: "#ff9800",
  },
  emergencyContent: {
    fontSize: "0.95rem",
    lineHeight: "1.4",
  },
};

export default ContactInfo;
